import React from 'react';

import Spinner from '@qality/common-components/src/atoms/atlaskit/Spinner';

import {
  ImportHeaderStyled,
  ImportMessageStyled,
  ImportStyled,
} from './Import.styled';

export const ImportView = () => {
  return (
    <ImportStyled>
      <ImportHeaderStyled>
        <h3>We are importing your Test Cases</h3>
        <h3>It may take a few minutes so please don’t close your browser</h3>
      </ImportHeaderStyled>
      <Spinner size={130} />
      <ImportMessageStyled>
        <span>But it is a perfect time to get some coffee!</span>
      </ImportMessageStyled>
    </ImportStyled>
  );
};
